/**
 * KIKI'S integration — REMOVED for EEZ7.
 *
 * The original platform bounced guests back to the KIKI'S partner website after
 * booking or paying for one specific restaurant. EEZ7 has no partner site, so
 * this module is an inert stub: every guard returns false and every redirect is
 * a no-op, keeping guests on the EEZ7 confirmation pages.
 *
 * It is kept as a stub rather than deleted because five pages import these
 * names (ReservationForm, EventTicketPayment, GuestPaymentSuccess,
 * PaymentSuccess, MembershipPaymentResult). Deleting the file would break those
 * imports; removing the call sites is a separate, larger cleanup. No KIKI'S URL
 * or restaurant id remains here, so no partner branding ships in the bundle.
 */

export const KIKIS_RESTAURANT_ID = null;
export const KIKIS_SITE_URL = '';
export const KIKIS_REDIRECT_DELAY_MS = 0;

export const isKikisRestaurant = () => false;
export const shouldRedirectToKikis = () => false;
export const shouldOpenKikisEventPage = () => false;

export const kikisProfileUrl = () => '';
export const kikisEventReserveUrl = () => '';

export const redirectToKikisEvent = () => false;
export const redirectToKikisProfile = () => false;

// Always inactive, so the "redirecting…" notice on the payment pages never renders.
export const useKikisProfileRedirect = () => false;
